import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const CONTAINER = "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8";

export const PageHero = ({ eyebrow, title, subtitle, image, ctaLabel = "Book a Free Consultation", ctaHref = "/book" }) => (
  <section className="relative isolate overflow-hidden" data-testid="page-hero">
    <img src={image} alt={title} className="absolute inset-0 h-full w-full object-cover" />
    <div className="absolute inset-0 mmm-hero-overlay-side" />
    <div className={`${CONTAINER} relative py-20 sm:py-28`}>
      <div className="max-w-2xl mmm-fade-up">
        {eyebrow && (
          <p className="text-[14px] font-semibold uppercase tracking-[0.14em] text-[#DEE029]">{eyebrow}</p>
        )}
        <h1 className="mt-3 text-4xl sm:text-5xl lg:text-6xl font-display font-bold tracking-tight text-white leading-[1.08]">
          {title}
        </h1>
        <p className="mt-5 text-lg sm:text-xl text-white/90 leading-relaxed">{subtitle}</p>
        <Link
          to={ctaHref}
          data-testid="page-hero-cta"
          className="mmm-tap mt-8 inline-flex items-center gap-2 px-7 h-14 rounded-full text-[17px] font-semibold text-white bg-[#9C1E22] hover:bg-[#861A1D] transition-colors"
        >
          {ctaLabel} <ArrowRight size={18} />
        </Link>
      </div>
    </div>
  </section>
);

export const FeatureGrid = ({ items }) => (
  <section className="py-16 sm:py-24">
    <div className={CONTAINER}>
      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {items.map((it, i) => (
          <div key={i} data-testid={`feature-${i}`} className="rounded-[0.9rem] bg-white border border-[#1C4358]/10 p-7 shadow-sm shadow-[#1C4358]/10">
            <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-[#9BB9CE]/25 text-[#1C4358]">
              <it.icon size={24} />
            </span>
            <h3 className="mt-4 text-xl font-display font-semibold text-[#1C4358]">{it.title}</h3>
            <p className="mt-2 text-[16px] text-[#4B5563] leading-relaxed">{it.body}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export const CTABand = ({ title, subtitle, ctaLabel = "Book a Free Consultation", ctaHref = "/book" }) => (
  <section className="pb-16 sm:pb-24">
    <div className={CONTAINER}>
      <div className="rounded-[1.4rem] bg-[#1C4358] mmm-grain px-6 py-12 sm:px-14 sm:py-16 text-center">
        <h2 className="text-3xl sm:text-4xl font-display font-bold tracking-tight text-white max-w-2xl mx-auto leading-tight">{title}</h2>
        {subtitle && <p className="mt-4 text-lg text-white/85 max-w-2xl mx-auto">{subtitle}</p>}
        <Link
          to={ctaHref}
          data-testid="cta-band-btn"
          className="mmm-tap mt-8 inline-flex items-center gap-2 px-8 h-14 rounded-full text-[17px] font-semibold text-[#1C4358] bg-[#DEE029] hover:bg-[#c9cb17] transition-colors"
        >
          {ctaLabel} <ArrowRight size={18} />
        </Link>
      </div>
    </div>
  </section>
);
